//Name: Bra Sizes
//Code: BRA
//Age: ''
//Gender: Female
const femaleBraSizes = [
  { id: '1', values: [
    {region: "AU", name: "08A"},
    {region: "NZ", name: "08A"},
    {region: "US", name: "30A"},
    {region: "UK", name: "30A"},
    {region: "EU", name: "65A"}
  ]},
  { id: '2', values: [
    {region: "AU", name: "10A"},
    {region: "NZ", name: "10A"},
    {region: "US", name: "32A"},
    {region: "UK", name: "32A"},
    {region: "EU", name: "70A"}
  ]},
  { id: '3', values: [
    {region: "AU", name: "12A"},
    {region: "NZ", name: "12A"},
    {region: "US", name: "34A"},
    {region: "UK", name: "34A"},
    {region: "EU", name: "75A"}
  ]},
  { id: '4', values: [
    {region: "AU", name: "14A"},
    {region: "NZ", name: "14A"},
    {region: "US", name: "36A"},
    {region: "UK", name: "36A"},
    {region: "EU", name: "80A"}
  ]},
  { id: '5', values: [
    {region: "AU", name: "16A"},
    {region: "NZ", name: "16A"},
    {region: "US", name: "38A"},
    {region: "UK", name: "38A"},
    {region: "EU", name: "85A"}
  ]},
  { id: '6', values: [
    {region: "AU", name: "08B"},
    {region: "NZ", name: "08B"},
    {region: "US", name: "30B"},
    {region: "UK", name: "30B"},
    {region: "EU", name: "65B"}
  ]},
  { id: '7', values: [
    {region: "AU", name: "10B"},
    {region: "NZ", name: "10B"},
    {region: "US", name: "32B"},
    {region: "UK", name: "32B"},
    {region: "EU", name: "70B"}
  ]},
  { id: '8', values: [
    {region: "AU", name: "12B"},
    {region: "NZ", name: "12B"},
    {region: "US", name: "34B"},
    {region: "UK", name: "34B"},
    {region: "EU", name: "75B"}
  ]},
  { id: '9', values: [
    {region: "AU", name: "14B"},
    {region: "NZ", name: "14B"},
    {region: "US", name: "36B"},
    {region: "UK", name: "36B"},
    {region: "EU", name: "80B"}
  ]},
  { id: '10', values: [
    {region: "AU", name: "16B"},
    {region: "NZ", name: "16B"},
    {region: "US", name: "38B"},
    {region: "UK", name: "38B"},
    {region: "EU", name: "85B"}
  ]},
  { id: '11', values: [
    {region: "AU", name: "18B"},
    {region: "NZ", name: "18B"},
    {region: "US", name: "40B"},
    {region: "UK", name: "40B"},
    {region: "EU", name: "90B"}
  ]},
  { id: '12', values: [
    {region: "AU", name: "20B"},
    {region: "NZ", name: "20B"},
    {region: "US", name: "42B"},
    {region: "UK", name: "42B"},
    {region: "EU", name: "95B"}
  ]},
  { id: '13', values: [
    {region: "AU", name: "22B"},
    {region: "NZ", name: "22B"},
    {region: "US", name: "44B"},
    {region: "UK", name: "44B"},
    {region: "EU", name: "100B"}
  ]},
  { id: '14', values: [
    {region: "AU", name: "24B"},
    {region: "NZ", name: "24B"},
    {region: "US", name: "46B"},
    {region: "UK", name: "46B"},
    {region: "EU", name: "105B"}
  ]},
  { id: '15', values: [
    {region: "AU", name: "08C"},
    {region: "NZ", name: "08C"},
    {region: "US", name: "30C"},
    {region: "UK", name: "30C"},
    {region: "EU", name: "65C"}
  ]},
  { id: '16', values: [
    {region: "AU", name: "10C"},
    {region: "NZ", name: "10C"},
    {region: "US", name: "32C"},
    {region: "UK", name: "32C"},
    {region: "EU", name: "70C"}
  ]},
  { id: '17', values: [
    {region: "AU", name: "12C"},
    {region: "NZ", name: "12C"},
    {region: "US", name: "34C"},
    {region: "UK", name: "34C"},
    {region: "EU", name: "75C"}
  ]},
  { id: '18', values: [
    {region: "AU", name: "14C"},
    {region: "NZ", name: "14C"},
    {region: "US", name: "36C"},
    {region: "UK", name: "36C"},
    {region: "EU", name: "80C"}
  ]},
  { id: '19', values: [
    {region: "AU", name: "16C"},
    {region: "NZ", name: "16C"},
    {region: "US", name: "38C"},
    {region: "UK", name: "38C"},
    {region: "EU", name: "85C"}
  ]},
  { id: '20', values: [
    {region: "AU", name: "18C"},
    {region: "NZ", name: "18C"},
    {region: "US", name: "40C"},
    {region: "UK", name: "40C"},
    {region: "EU", name: "90C"}
  ]},
  { id: '21', values: [
    {region: "AU", name: "20C"},
    {region: "NZ", name: "20C"},
    {region: "US", name: "42C"},
    {region: "UK", name: "42C"},
    {region: "EU", name: "95C"}
  ]},
  { id: '22', values: [
    {region: "AU", name: "22C"},
    {region: "NZ", name: "22C"},
    {region: "US", name: "44C"},
    {region: "UK", name: "44C"},
    {region: "EU", name: "100C"}
  ]},
  { id: '23', values: [
    {region: "AU", name: "24C"},
    {region: "NZ", name: "24C"},
    {region: "US", name: "46C"},
    {region: "UK", name: "46C"},
    {region: "EU", name: "105C"}
  ]},
  { id: '24', values: [
    {region: "AU", name: "08D"},
    {region: "NZ", name: "08D"},
    {region: "US", name: "30D"},
    {region: "UK", name: "30D"},
    {region: "EU", name: "65D"}
  ]},
  { id: '25', values: [
    {region: "AU", name: "10D"},
    {region: "NZ", name: "10D"},
    {region: "US", name: "32D"},
    {region: "UK", name: "32D"},
    {region: "EU", name: "70D"}
  ]},
  { id: '26', values: [
    {region: "AU", name: "12D"},
    {region: "NZ", name: "12D"},
    {region: "US", name: "34D"},
    {region: "UK", name: "34D"},
    {region: "EU", name: "75D"}
  ]},
  { id: '27', values: [
    {region: "AU", name: "14D"},
    {region: "NZ", name: "14D"},
    {region: "US", name: "36D"},
    {region: "UK", name: "36D"},
    {region: "EU", name: "80D"}
  ]},
  { id: '28', values: [
    {region: "AU", name: "16D"},
    {region: "NZ", name: "16D"},
    {region: "US", name: "38D"},
    {region: "UK", name: "38D"},
    {region: "EU", name: "85D"}
  ]},
  { id: '29', values: [
    {region: "AU", name: "18D"},
    {region: "NZ", name: "18D"},
    {region: "US", name: "40D"},
    {region: "UK", name: "40D"},
    {region: "EU", name: "90D"}
  ]},
  { id: '30', values: [
    {region: "AU", name: "20D"},
    {region: "NZ", name: "20D"},
    {region: "US", name: "42D"},
    {region: "UK", name: "42D"},
    {region: "EU", name: "95D"}
  ]},
  { id: '31', values: [
    {region: "AU", name: "22D"},
    {region: "NZ", name: "22D"},
    {region: "US", name: "44D"},
    {region: "UK", name: "44D"},
    {region: "EU", name: "100D"}
  ]},
  { id: '32', values: [
    {region: "AU", name: "24D"},
    {region: "NZ", name: "24D"},
    {region: "US", name: "46D"},
    {region: "UK", name: "46D"},
    {region: "EU", name: "105D"}
  ]},
  { id: '33', values: [
    {region: "AU", name: "10DD"},
    {region: "NZ", name: "10DD"},
    {region: "US", name: "32DD"},
    {region: "UK", name: "32DD"},
    {region: "EU", name: "70DD"}
  ]},
  { id: '34', values: [
    {region: "AU", name: "12DD"},
    {region: "NZ", name: "12DD"},
    {region: "US", name: "34DD"},
    {region: "UK", name: "34DD"},
    {region: "EU", name: "75DD"}
  ]},
  { id: '35', values: [
    {region: "AU", name: "14DD"},
    {region: "NZ", name: "14DD"},
    {region: "US", name: "36DD"},
    {region: "UK", name: "36DD"},
    {region: "EU", name: "80DD"}
  ]},
  { id: '36', values: [
    {region: "AU", name: "16DD"},
    {region: "NZ", name: "16DD"},
    {region: "US", name: "38DD"},
    {region: "UK", name: "38DD"},
    {region: "EU", name: "85DD"}
  ]},
  { id: '37', values: [
    {region: "AU", name: "18DD"},
    {region: "NZ", name: "18DD"},
    {region: "US", name: "40DD"},
    {region: "UK", name: "40DD"},
    {region: "EU", name: "90DD"}
  ]},
  { id: '38', values: [
    {region: "AU", name: "20DD"},
    {region: "NZ", name: "20DD"},
    {region: "US", name: "42DD"},
    {region: "UK", name: "42DD"},
    {region: "EU", name: "95DD"}
  ]},
  { id: '39', values: [
    {region: "AU", name: "22DD"},
    {region: "NZ", name: "22DD"},
    {region: "US", name: "44DD"},
    {region: "UK", name: "44DD"},
    {region: "EU", name: "100DD"}
  ]},
  { id: '40', values: [
    {region: "AU", name: "24DD"},
    {region: "NZ", name: "24DD"},
    {region: "US", name: "46DD"},
    {region: "UK", name: "46DD"},
    {region: "EU", name: "105DD"}
  ]},
  { id: '162', values: [
    {region: "AU", name: "10E"},
    {region: "NZ", name: "10E"},
    {region: "US", name: "32DDD"},
    {region: "UK", name: "32E"},
    {region: "EU", name: "70DDD"}
  ]},
  { id: '163', values: [
    {region: "AU", name: "12E"},
    {region: "NZ", name: "12E"},
    {region: "US", name: "34DDD"},
    {region: "UK", name: "34E"},
    {region: "EU", name: "75DDD"}
  ]},
  { id: '164', values: [
    {region: "AU", name: "14E"},
    {region: "NZ", name: "14E"},
    {region: "US", name: "36DDD"},
    {region: "UK", name: "36E"},
    {region: "EU", name: "80DDD"}
  ]},
  { id: '165', values: [
    {region: "AU", name: "16E"},
    {region: "NZ", name: "16E"},
    {region: "US", name: "38DDD"},
    {region: "UK", name: "38E"},
    {region: "EU", name: "85DDD"}
  ]},
  { id: '166', values: [
    {region: "AU", name: "18E"},
    {region: "NZ", name: "18E"},
    {region: "US", name: "40DDD"},
    {region: "UK", name: "40E"},
    {region: "EU", name: "90DDD"}
  ]},
  { id: '167', values: [
    {region: "AU", name: "20E"},
    {region: "NZ", name: "20E"},
    {region: "US", name: "42DDD"},
    {region: "UK", name: "42E"},
    {region: "EU", name: "95DDD"}
  ]},
  { id: '168', values: [
    {region: "AU", name: "22E"},
    {region: "NZ", name: "22E"},
    {region: "US", name: "44DDD"},
    {region: "UK", name: "44E"},
    {region: "EU", name: "100DDD"}
  ]},
  { id: '169', values: [
    {region: "AU", name: "24E"},
    {region: "NZ", name: "24E"},
    {region: "US", name: "46DDD"},
    {region: "UK", name: "46E"},
    {region: "EU", name: "105DDD"}
  ]},
  { id: '41', values: [
    {region: "AU", name: "10F"},
    {region: "NZ", name: "10F"},
    {region: "US", name: "32F"},
    {region: "UK", name: "32F"},
    {region: "EU", name: "70F"}
  ]},
  { id: '42', values: [
    {region: "AU", name: "12F"},
    {region: "NZ", name: "12F"},
    {region: "US", name: "34F"},
    {region: "UK", name: "34F"},
    {region: "EU", name: "75F"}
  ]},
  { id: '43', values: [
    {region: "AU", name: "14F"},
    {region: "NZ", name: "14F"},
    {region: "US", name: "36F"},
    {region: "UK", name: "36F"},
    {region: "EU", name: "80F"}
  ]},
  { id: '44', values: [
    {region: "AU", name: "16F"},
    {region: "NZ", name: "16F"},
    {region: "US", name: "38F"},
    {region: "UK", name: "38F"},
    {region: "EU", name: "85F"}
  ]},
  { id: '45', values: [
    {region: "AU", name: "18F"},
    {region: "NZ", name: "18F"},
    {region: "US", name: "40F"},
    {region: "UK", name: "40F"},
    {region: "EU", name: "90F"}
  ]},
  { id: '46', values: [
    {region: "AU", name: "20F"},
    {region: "NZ", name: "20F"},
    {region: "US", name: "42F"},
    {region: "UK", name: "42F"},
    {region: "EU", name: "95F"}
  ]},
  { id: '47', values: [
    {region: "AU", name: "22F"},
    {region: "NZ", name: "22F"},
    {region: "US", name: "44F"},
    {region: "UK", name: "44F"},
    {region: "EU", name: "100F"}
  ]},
  { id: '48', values: [
    {region: "AU", name: "24F"},
    {region: "NZ", name: "24F"},
    {region: "US", name: "46F"},
    {region: "UK", name: "46F"},
    {region: "EU", name: "105F"}
  ]}
];

export default femaleBraSizes;



// WEBPACK FOOTER //
// ./src/data/female-bra-sizes.js